import { render, staticRenderFns } from "./SignalIndicatorBO.vue?vue&type=template&id=6c5a53a6&scoped=true&"
import script from "./SignalIndicatorBO.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalIndicatorBO.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a53a6",
  null
  
)

export default component.exports